import Vue from 'vue'
import MoneySpinner from 'v-money-spinner'

Vue.use(MoneySpinner)

// A máscara da lib é de "caixa registradora": os dígitos entram pela direita
// (1 → 0,01 → 12 → 0,12 ...). Mas ela preserva o cursor onde o usuário clicou,
// e o texto do campo é centralizado: clicar à esquerda de "R$ 0,00" deixa o
// cursor antes do 0, digitar 1 vira "R$ 10,00" e o 2 seguinte entra no meio
// ("R$ 120,00"). Ao focar: campo zerado/vazio fica com o cursor no fim; campo
// com valor fica todo selecionado, e digitar substitui o valor (antes era
// preciso apagar tudo). Cada dígito digitado com o cursor no meio vai para o
// fim. Seleções feitas pelo usuário (arrastar, duplo clique) são respeitadas.
const ehInputDoCampo = (evento) => evento.target && evento.target.tagName === 'INPUT'

const temValor = (input) => /[1-9]/.test(input.value)

const moverCursorParaFim = (input, sufixo) => {
    if (input !== document.activeElement) return
    if (input.selectionStart !== input.selectionEnd) return
    const fim = Math.max(0, input.value.length - sufixo.length)
    if (input.selectionEnd !== fim) input.setSelectionRange(fim, fim)
}

const posicionarAoFocar = (input, sufixo) => {
    if (input !== document.activeElement) return
    if (temValor(input)) {
        input.setSelectionRange(0, input.value.length)
        return
    }
    moverCursorParaFim(input, sufixo)
}

// A lib formata o valor no watcher sem tratar null/undefined (só '' com
// allowBlank) e estoura `null.startsWith`. Colunas monetárias nullable chegam
// como null. Quando o valor VIRA null, remonta o spinner (troca de `key`) em
// vez de repassar a mudança: no watcher a lib reformataria '' e devolveria 0
// ao v-model (serviço sem preço seria salvo com R$ 0,00). Na montagem o
// `created` da lib ignora valores falsy e não emite nada. A volta (null →
// número) NÃO remonta: é o primeiro dígito digitado num campo vazio, e remontar
// ali tirava o foco do input — o resto da digitação se perdia ("R$ 10,00").
const VMoneySpinnerOriginal = Vue.component('VMoneySpinner')
Vue.component('VMoneySpinner', {
    name: 'VMoneySpinnerSeguro',
    inheritAttrs: false,
    props: { value: { default: null } },
    data: () => ({ versaoVazio: 0 }),
    watch: {
        value(novo, antigo) {
            const vazio = (v) => v === null || v === undefined
            if (vazio(novo) && !vazio(antigo)) this.versaoVazio++
        },
    },
    created() {
        this.cursorAcabouDeFocar = false
    },
    methods: {
        sufixo() {
            return this.$attrs.suffix || ''
        },
        onFocusin(evento) {
            if (!ehInputDoCampo(evento)) return
            const input = evento.target
            this.cursorAcabouDeFocar = true
            // A lib reposiciona o cursor no próprio focus e de novo após 1ms.
            setTimeout(() => posicionarAoFocar(input, this.sufixo()), 10)
        },
        onMouseup(evento) {
            if (!ehInputDoCampo(evento) || !this.cursorAcabouDeFocar) return
            this.cursorAcabouDeFocar = false
            const input = evento.target
            // O clique (mousedown) posiciona o cursor depois do focus.
            evento.preventDefault()
            posicionarAoFocar(input, this.sufixo())
        },
        onKeydown(evento) {
            if (!ehInputDoCampo(evento)) return
            this.cursorAcabouDeFocar = false
            if (evento.ctrlKey || evento.metaKey || evento.altKey) return
            if (!/^\d$/.test(evento.key)) return
            moverCursorParaFim(evento.target, this.sufixo())
        },
    },
    render(h) {
        const vazio = this.value === null || this.value === undefined
        const value = vazio ? '' : this.value
        return h(VMoneySpinnerOriginal, {
            key: this.versaoVazio,
            attrs: { ...this.$attrs, value },
            on: this.$listeners,
            nativeOn: {
                focusin: this.onFocusin,
                mouseup: this.onMouseup,
                keydown: this.onKeydown,
            },
            scopedSlots: this.$scopedSlots,
        })
    },
})
